import { otpSchema } from '@edgevanta/domains/client';

import { z } from 'zod/v4';

export const signInWithEmailSchema = z.object({
  email: z.string().email().toLowerCase(),
});

export const signInWithOTPSchema = signInWithEmailSchema.extend({
  otp: otpSchema,
});
